import React from 'react'

function AtmBranches() {
  return (
   <>
   <section className='atm_branches_section'>
    <div className='container'>
      <div className='row justify-content-between'>
      <div className='col-md-6 co-12'>
        <div className='atm_branch_wrapper'>
          <div className='atm_img'>
          <img
          src="./dist/img/atm.webp"
          alt="atm"
          className="img-fluid"
          height={156}
          width={233}
        />
          </div>
          <div className='atm_branch_content'>
             <span>13,376+</span>
             <h4>ATM/CRM across India</h4>
          </div>
        </div>
      </div>
      <div className='col-md-6 co-12'>
        <div className='atm_branch_wrapper auto'>
          <div className='branch_img'>
          <img
          src="./dist/img/branch.webp"
          alt="atm"
          className="img-fluid"
          height={156}
          width={232}
        />
          </div>
          <div className='atm_branch_content'>
             <span>7,066+</span>
             <h4>Branches across India</h4>
             
          </div>
        </div>
      </div>
      </div>
    </div>
   </section>
   </>
  )
}

export default AtmBranches